import { FC } from "react"


export type SubmitButtonProps = {
    clickHandler: React.MouseEventHandler<HTMLButtonElement>
    buttonText: String
}

const SubmitButton: FC<SubmitButtonProps> = ({clickHandler, buttonText}) => {
    return (
    <button className="my-2 mx-4 px-2 border border-black float-right"
              onClick={clickHandler}
            >
              {buttonText}
            </button>
    )
}

export default SubmitButton